// import React from "react";
// import { Typography } from "@mui/material";
// import { styled } from "@mui/system";
// export default function IPDCFormHeader({ title }) {
//   const FormHeader = styled(Typography)(({ theme }) => ({
//     marginBottom: theme.spacing(2),
//     textAlign: "center",
//     fontWeight: "bold",
//   }));
//   return (
//     <FormHeader variant="h4" noWrap>
//       {title}
//     </FormHeader>
//   );
// }
import React from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export default function IPDCFormHeader({ 
  title,
  // Based on the image "Edit Investor Activities"
  fontFamily = '"Times New Roman", Times, serif',
  fontSize = "18px", // Direct px for precision
  fontWeight = "bold", // Looks bold in the image
  color = "#000080", // Pure black
  align = "left",
  letterSpacing = "normal",
  lineHeight = 1.2,
  mb = 3, // More spacing at bottom
  mt = 0,
  borderBottom = "none", // No border in the image
  paddingBottom = "4px",
  sx = {}
}) {
  
  const FormHeader = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(mb),
    marginTop: theme.spacing(mt),
    textAlign: align,
    fontWeight: fontWeight,
    fontFamily: fontFamily,
    fontSize: fontSize,
    color: color,
    letterSpacing: letterSpacing,
    lineHeight: lineHeight,
    borderBottom: borderBottom,
    paddingBottom: paddingBottom,
    // From the image, it looks like it has some bottom margin/padding
    padding: "0 0 8px 0",
    // Text properties from image
    textTransform: "none", // Not uppercase
    display: "block",
    width: "100%",
    // Ensure text doesn't wrap
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }));
  
  return (
    <FormHeader 
      variant="h5" // h5 gives slightly larger size than h6
      sx={sx}
    >
      {title}
    </FormHeader>
  );
}